import { useMutation } from '@tanstack/react-query'

import {
  type PaymentResultRequest,
  type PaymentStartRequest,
  postRefundPayment,
  postResultPayment,
  postStartPayment,
} from '~/features/payment/apis/payment'

export const usePostStartPayment = () => {
  return useMutation({
    mutationFn: ({
      paymentInfo: { goods_id, divide, quantity, option_1_quantity },
    }: PaymentStartRequest) =>
      postStartPayment({
        paymentInfo: { goods_id, divide, quantity, option_1_quantity },
      }),
  })
}

export const usePostResultPayment = () => {
  return useMutation({
    mutationFn: ({
      paymentInfo: {
        success,
        order_code,
        payment_key,
        amount,
        payment_type,
        error_code,
      },
    }: PaymentResultRequest) =>
      postResultPayment({
        paymentInfo: {
          success,
          order_code,
          payment_key,
          amount,
          payment_type,
          error_code,
        },
      }),
  })
}

export const usePostRefundPayment = () => {
  return useMutation({
    mutationFn: (id: number) => postRefundPayment(id),
  })
}
